<template>
  <div
    v-if="!isVisitor && profile.is_blurred_avatar"
    class="profile-card__grid profile-card__image profile-card__image--small profile-card__image--zoom-in profile-card__image--blurred clickable overflow-hidden"
    v-on:click="emitBuy"
  >
    <div class="profile-card__info profile-card__info--top-choice" v-if="true">
      {{ profile.top_choice_slogan }}
    </div>

    <div class="profile-card__image profile-card__image--small profile-card__image--blurred position-absolute" v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + '?h=480)' }"></div>
  </div>

  <div
    v-else-if="isVisitor && profile.is_blurred_avatar"
    class="profile-card__grid profile-card__image profile-card__image--small profile-card__image--zoom-in profile-card__image--blurred clickable"
    v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + '?h=480)' }"
    v-on:click="emitBuy"
  >
    <div class="profile-card__bottom-bar">
      <span class="profile-card__bottom-bar-text">Freischalten</span>
      <img class="profile-card__lock-icon" src="./../../../images/others/lock-icon.png" alt="">

    </div>
  </div>


  <router-link v-else :to="{name: 'profile', params: { id: profile.id}}" class="unset">
    <div
      class="profile-card__grid profile-card__image profile-card__image--small profile-card__image--zoom-in profile-card__image--inner-shadow clickable"
      v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + '?h=450)' }"
    >

      <div class="profile-card__info">
        <div class="profile-card__card-data">

          <div class="data-wrapper">
            <h6 class="card-data__name">{{ profile.name }}
              <span v-if="profile.is_online" class="dot-online members__online"></span>
            </h6>
            <span class="card-data__age">
                            {{ profile.age }}
                        </span>
            <p class="card-data__city" v-if="profile.address_form !== 'hidden' && profile.location">
              {{ profile.address_city }} , {{ parseInt(profile.location.distance) }} km
            </p>
          </div>
        </div>
      </div>
      <div class="profile-card__new-user">
        <div v-if="profile.is_new" class="label-card">{{ trans.get('pages:members.profile_card.new') }}</div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'ProfileCard',
  props: {
    profile: Object,
    isTopChoice: Boolean,
    isVisitor: Boolean,
    isOther: Boolean,
  },
  methods: {
    emitBuy: function () {
      this.$emit('buy', { profileId: this.profile.id, isOther: this.isOther, profileAvatar: this.profile.avatar_url });
    }
  }
};
</script>

<style scoped>

</style>
